module.exports = __webpack_public_path__ + "static/media/icon-aceleracaobrusca-cinza.e70f5848.svg";